import { useEffect, useState } from 'react';
import Navbar from '../../components/CommonComponents/Navbar/Navbar';
import BuyerProfileDetailsSection from '../../components/PageComponents/ProfileDetailsPageComponents/BuyerProfileDetailsSection/BuyerProfileDetailsSection';
import { ProfileVisibilityTypeEnum } from '../../enums/ProfileVisibilityTypeEnum';
import './MyProfilePage.scss';
import { BuyerAPIHandler } from '../../services/NetworkClient/BackendAPIs/BuyerAPIHandler';
import GGLoaderView from '../../components/UtilityComponents/GGLoaderView/GGLoaderView';
import { SessionManager } from '../../services/SessionManager/SessionManager';
import { Buyer } from '../../Models/Buyer';
import Footer from '../../components/CommonComponents/Footer/Footer';
import logAnalyticsEvent from '../../services/AnalyticsManager/AnalyticsManager';
import { GGAnalyticsEvents } from '../../services/AnalyticsManager/GGAnalyticsEvents';
import SellerProfileDetailsSection from '../../components/PageComponents/ProfileDetailsPageComponents/SellerProfileDetailsSection/SellerProfileDetailsSection';

const MyProfilePage = () => {

  const [buyer, setBuyer] = useState<Buyer | undefined>(undefined)
  const [showLoader, setShowLoader] = useState(true)

  useEffect(() => {
    document.title = "GenieGig | My Profile";    
    window.scrollTo(0,0);
    logAnalyticsEvent(GGAnalyticsEvents.MY_PROFILE_PAGE_LOADED);

    const getUserData = async () => {
        try {
            let buyer = SessionManager.shared.buyer || await BuyerAPIHandler.shared.getBuyerByAuthToken()
            SessionManager.shared.buyer = buyer
            setBuyer(buyer)
            setShowLoader(false)
        } catch (err) {
            setShowLoader(false)
        }
    }

    getUserData()
}, [])
  
  return (
    <div>
      {showLoader && <GGLoaderView />}
      <Navbar useScrollVersion={true}/>

      {buyer?.seller !== undefined ? (
        <SellerProfileDetailsSection sellerId={buyer.seller} visibility={ProfileVisibilityTypeEnum.MyProfile} />
      ) : (
        buyer && <BuyerProfileDetailsSection buyerObject={buyer} visibility={ProfileVisibilityTypeEnum.MyProfile} />
      )}
      <Footer />
    </div>
  )
}

export default MyProfilePage